import {Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges} from '@angular/core';
import {remainingSeconds, timer} from '@npck/libs/commons';
import {Subscription} from 'rxjs';

@Component({
    selector: 'ui-kit-timer',
    templateUrl: 'timer.component.html',
    standalone: false
})
export class TimerComponent implements OnDestroy, OnChanges {
    @Input({required: true}) totalDurationSec: number;
    @Input() translationKey: string;
    @Input() timerStartTime = new Date().getTime();
    @Input() startImmediately = false;
    @Input() paused = false;
    @Output() timerExpired = new EventEmitter<void>();

    time: number;
    private subscription: Subscription;

    ngOnChanges(changes: SimpleChanges): void {
        if (Object.keys(changes).every(key => changes[key].currentValue === changes[key].previousValue)) {
            return;
        }
        this.subscription?.unsubscribe();
        if (this.paused) {
            this.freeze(changes);
            return;
        }
        const resumedAtBoundary = changes.paused?.previousValue === true && !changes.totalDurationSec;
        const durationSec = resumedAtBoundary ? this.time : this.totalDurationSec;
        const startTime = resumedAtBoundary ? new Date().getTime() : this.timerStartTime;
        this.time = remainingSeconds(startTime, durationSec);
        this.subscription = timer(startTime, durationSec, this.startImmediately)
            .subscribe({
                next: time => this.time = time,
                complete: () => this.timerExpired.emit(),
            });
    }

    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
    }

    private freeze(changes: SimpleChanges): void {
        if (changes.totalDurationSec || this.time == null) {
            this.time = this.totalDurationSec;
        }
    }
}
